import { createVerification } from './bb-free-verification.js?v=20261009-auto4';
const products=new Set(['fullwidth-lined','evenmargin-lined','dot-grid','graph']);
export function approvedEndpoint(value){const u=new URL(value);if(u.protocol!=='https:'||u.username||u.password||u.search||u.hash||u.pathname!=='/api/free-requests')throw Error('Invalid endpoint');return u}
export function checkedDownloads(data,endpoint){
 if(data.downloadPolicy!=='pdf-30d-2026-10-09'||data.mode!=='live'||!Array.isArray(data.downloads)||data.downloads.length!==2)throw Error('Invalid download response');
 return ['letter','half-letter'].map(size=>{
  const items=data.downloads.filter(d=>d.size===size);if(items.length!==1)throw Error('Invalid paper sizes');
  const url=new URL(items[0].url);if(url.origin!==endpoint.origin||url.pathname!=='/download'||url.username||url.password||url.hash||!url.searchParams.get('token'))throw Error('Invalid download URL');
  return {size,url:url.href};
 });
}
export function initFreeForm(form){
 if(form.dataset.initialized)return;form.dataset.initialized='true';
 form.addEventListener('submit',event=>event.preventDefault());
 if(form.dataset.enabled!=='true'||!products.has(form.dataset.product))return;
 const status=form.querySelector('[data-free-status]');
 let endpoint,labels;try{endpoint=approvedEndpoint(form.dataset.endpoint);labels=JSON.parse(form.querySelector('[data-free-labels]').textContent)}catch{status.textContent=form.dataset.unavailable||'Downloads are being prepared. Please check back soon.';return}
 const downloadOnly=form.dataset.downloadOnly==='true';
 const verificationOnly=downloadOnly&&form.dataset.verificationTest==='true';
 const panel=form.querySelector('[data-bb-verification]');
 const verification=panel?createVerification({panel,widgetHost:form.querySelector('[data-turnstile-widget]'),message:form.querySelector('[data-verification-message]'),retry:form.querySelector('[data-verification-retry]'),sitekey:form.dataset.turnstileSitekey,endpoint,labels,verificationOnly}):null;
 form.addEventListener('input',()=>verification?.cancel());
 const newsletter=form.parentElement?.querySelector('[data-bb-newsletter]');
 const restoreName='bb-free-result:pdf-v2-30day:'+endpoint.origin+':'+form.dataset.product+(downloadOnly?':download-only':'');
 const fieldset=form.querySelector('fieldset'),button=form.querySelector('button'),links=form.querySelector('[data-free-links]');
 const showDownloads=(data,email)=>{
  const downloads=checkedDownloads(data,endpoint);links.replaceChildren();
  for(const download of downloads){const a=document.createElement('a');a.href=download.url;a.textContent=download.size==='letter'?labels.download_letter:labels.download_half_letter;a.className='bb-button';a.referrerPolicy='no-referrer';links.append(a)}
  const notice=document.createElement('p');notice.textContent=labels.expiry_notice;notice.className='bb-small bb-muted';links.append(notice);
  if(newsletter){newsletter.hidden=false;const input=newsletter.querySelector('[name="contact[email]"]');if(input&&email)input.value=email}
 };
 try{const saved=JSON.parse(sessionStorage.getItem(restoreName));if(saved?.expiresAt>Date.now()){showDownloads(saved);status.textContent=labels.ready}}catch{}
 let pending=false,key=null,previous=null,storageName=null;fieldset.disabled=false;
 form.addEventListener('submit',async()=>{
  if(pending||!form.reportValidity())return;
  const fields=new FormData(form),body=JSON.stringify({product:form.dataset.product,email:fields.get('email'),website:fields.get('website')||'',deliveryVersion:'v2'});
  const changed=body!==previous;if(changed&&previous!==null)links.replaceChildren();
  verification?.cancel();
  pending=true;fieldset.disabled=true;button.disabled=true;status.textContent=labels.preparing;
  let successful=false;
  const request=async(url,payload,requestKey)=>fetch(url,{method:'POST',mode:'cors',credentials:'omit',redirect:'error',headers:{'Content-Type':'application/json',...(requestKey?{'Idempotency-Key':requestKey}:{})},body:payload,signal:AbortSignal.timeout(15000)});
  try{
   if(changed||!key){
    previous=body;key=null;storageName=null;
    try{const digest=await crypto.subtle.digest('SHA-256',new TextEncoder().encode(endpoint.href+body));storageName='bb-free-request:pdf-v2-30day:'+Array.from(new Uint8Array(digest),n=>n.toString(16).padStart(2,'0')).join('');key=sessionStorage.getItem(storageName)}catch{/* Current form still retains its key if storage is unavailable. */}
    if(!key){key=`${Date.now()}_${crypto.randomUUID()}`;try{if(storageName)sessionStorage.setItem(storageName,key)}catch{}}
   }
   const response=await request(endpoint.href,body,key);
   if(response.status===410){key=null;try{sessionStorage.removeItem(storageName)}catch{}status.textContent=labels.expired;return}
   if(response.status===400){status.textContent=labels.invalid;return}
   if(response.status===422){status.textContent=labels.refresh;return}
   if(response.status===429){status.textContent=labels.limited;return}
   if(!response.ok)throw Error('Request failed');
   const data=await response.json(),downloads=checkedDownloads(data,endpoint);
   showDownloads(data,fields.get('email'));
   try{sessionStorage.setItem(restoreName,JSON.stringify({mode:data.mode,downloadPolicy:data.downloadPolicy,downloads:data.downloads,expiresAt:Date.parse(data.expiresAt)}))}catch{}
   successful=true;links.querySelector('a')?.focus();
   if(downloadOnly){
    status.textContent=labels.ready;
    if(verificationOnly)verification?.prepare(data);
    return;
   }
   status.textContent=labels.ready;
   if(typeof data.receipt!=='string')throw Error('Invalid receipt');
   if(!verification){status.textContent=labels.not_attempted+' '+labels.verification_unavailable;return}
   verification.prepare(data,{automatic:true});
  }catch{status.textContent=successful?labels.unknown:labels.retry}finally{pending=false;fieldset.disabled=false;button.disabled=false;if(!successful)button.focus()}
 });
}
if(typeof document!=='undefined'){
 const initialize=root=>root.querySelectorAll('[data-bb-free-form]').forEach(initFreeForm);
 initialize(document);document.addEventListener('shopify:section:load',event=>initialize(event.target));
}



